import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { WifiConnectionLoaderService } from '@services/wifi-connection-loader.service';

const WIFI_LOADER_PATHS = [
  'connectivity/connectivityWorker',
  'api/register/register',
];

@Injectable()
export class WifiConnectionLoaderInterceptor implements HttpInterceptor {
  constructor(private wifiConnectionLoaderService: WifiConnectionLoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.shouldShowWifiLoader(request.url)) {
      return next.handle(request);
    }

    this.wifiConnectionLoaderService.show();

    return next.handle(request).pipe(
      finalize(() => this.wifiConnectionLoaderService.hide())
    );
  }

  private shouldShowWifiLoader(url: string): boolean {
    return WIFI_LOADER_PATHS.some(path => url.includes(path));
  }
}
